import { createFileRoute } from "@tanstack/react-router"
import { lazy } from "react"
import LazyRoutePage from "../../../../-LazyRoutePage"

type Search = {
  tab?: "general" | "info" | "files"
  edit?: 1
}

type RawSearch = {
  tab?: unknown
  edit?: unknown
}

const DocumentMMWPage = lazy(() =>
  import(
    "../../../../../components/WMS/Transfers/MMW/DocumentMMWPage.tsx"
  ).then((module) => ({ default: module.DocumentMMWPage })),
)

export const Route = createFileRoute("/_layout/WMS/documents/doc-mmw/$docMmw")({
  validateSearch: (search: RawSearch): Search => ({
    tab:
      search.tab === "info"
        ? "info"
        : search.tab === "files"
          ? "files"
          : "general",
    edit: search.edit === 1 || search.edit === "1" ? 1 : undefined,
  }),
  component: DocumentMMWRoute,
})

function DocumentMMWRoute() {
  return (
    <LazyRoutePage>
      <DocumentMMWPage />
    </LazyRoutePage>
  )
}
